import { render } from "./showAudio.vue?vue&type=template&id=8f6de3fe&scoped=true"
import script from "./showAudio.vue?vue&type=script&lang=js"
export * from "./showAudio.vue?vue&type=script&lang=js"

import "./showAudio.vue?vue&type=style&index=0&id=8f6de3fe&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f6de3fe"]])

export default __exports__